import React from 'react';
import { 
    Box, 
    Button, Flex, 
    Icon,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure, 
} from '@chakra-ui/react';
import { useDataTable } from './hooks/useDataTable';
import TableSheetTitleEditable from './TableSheetTitle';
import CreateNewTableButton from './CreateTableButton';
import { BsChevronDown, BsFilter, BsTable, BsTrash } from 'react-icons/bs';
import { PropertiesDropdown } from './dropdowns/PropertiesDropDown';
import { SearchProperty } from './property/SearchProperty';
import { GroupsDropdown } from './dropdowns/GroupsDropdown';
import DataTable from './DataTable';
import { createRandomUuid } from '../../utilities/others';
import { CustomTableProps } from './Table.types';

export default function CustomTable({ 
    propertyList, 
    groupList, 
    tableType, 
    dataByGroup, 
    onGroupItemClick,
    onGroupSelectionClear 
}: CustomTableProps) {    
    const { tableProps, properties, handleAddRow, reorderRow } = useDataTable({ tableData: dataByGroup || [], propertyList});

    const { getSelectedRowModel, getIsAllPageRowsSelected, getIsSomeRowsSelected } = tableProps;  
    const { isOpen, onOpen, onClose } = useDisclosure();

    const newSheetId = createRandomUuid();
        
    return (
        <>
            <Box paddingBottom='1rem'>
                <Flex
                    marginBottom="1rem"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Flex alignItems="center">
                        <TableSheetTitleEditable sheet={{ name: "New Sheet", id: newSheetId }} />
                    </Flex>
                    <Box>
                        <CreateNewTableButton>
                            <Button size="xs" variant="solid" colorScheme={'blue'}  rightIcon={<BsChevronDown />}>
                                New
                            </Button>
                        </CreateNewTableButton>
                    </Box>
                </Flex>

                <Flex alignItems="center" justifyContent="space-between">
                    {/* Groups */}
                    <Flex alignItems="center">
                        <GroupsDropdown 
                            data={groupList!} 
                            type={tableType} 
                            onGroupItemClick={onGroupItemClick} 
                            onGroupSelectionClear={onGroupSelectionClear}
                        >
                            <Button 
                                size="xs" 
                                leftIcon={<BsTable />} 
                                variant='solid' 
                                colorScheme={'gray'} 
                                rightIcon={<BsChevronDown />}
                            >
                                Select table
                            </Button>
                        </GroupsDropdown>
                        <Box>
                            {(getIsAllPageRowsSelected() || getIsSomeRowsSelected()) && (
                                <>
                                    <Button 
                                        color='gray.500' 
                                        variant='ghost' 
                                        size={'sm'} 
                                        marginLeft={'4'} 
                                        _focus={{ boxShadow: 'none', border: 'none', bg: 'transparent' }}
                                        _hover={{ boxShadow: 'none', border: 'none', bg: 'transparent', color: 'red.500' }}
                                        onClick={onOpen}
                                    >
                                        <span>
                                            {getSelectedRowModel()?.rows.length} 
                                        </span>
                                        <span style={{ marginLeft: '4px' }}>
                                            {getSelectedRowModel()?.rows.length > 1 ? 'rows' : 'row'}  selected
                                        </span>
                                        <Icon as={BsTrash} size={'sm'} marginLeft='1' />
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Flex>

                    {/* Properties */}
                    <Flex alignItems="center" justifyContent="space-between">
                        <Box marginRight="0.5rem">
                            <PropertiesDropdown {...properties}>
                                <Button size="xs" fontWeight={'semibold'} leftIcon={<BsFilter />} variant="ghost">
                                    Properties
                                </Button>
                            </PropertiesDropdown>
                        </Box>
                        <Box marginRight="0.5rem">
                            {/* <FiltersDropdown properties={properties.properties}>
                                <Button size="xs" leftIcon={<BsFunnel />} variant="ghost">
                                Filter
                                </Button>
                            </FiltersDropdown> */}
                        </Box>
                        <Box marginRight="0.5rem">
                            {/* <SortDropdown properties={properties.properties}>
                                <Button size="xs" fontWeight={'semibold'} leftIcon={<BsSortDown />} variant="ghost">
                                    Sort
                                </Button>
                            </SortDropdown> */}
                        </Box>
                        <Box>
                            <SearchProperty />
                        </Box>
                    </Flex>
                </Flex>
            </Box>

            <DataTable 
                {...tableProps} 
                {...properties}
                onAddRow={handleAddRow} 
                reorderRow={reorderRow}
            />

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Delete selected rows</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        Do you want to delete the {getSelectedRowModel()?.rows.length} {getSelectedRowModel()?.rows.length > 1 ? 'rows' : 'row'} selected?
                    </ModalBody>

                <ModalFooter>
                    <Button variant='ghost' mr={3} onClick={onClose}>Cancel</Button>
                    <Button colorScheme='red'>
                        Delete
                    </Button>
                </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}